import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios-dashboard';
import { baseUrlAlertas, } from '../../assets/shared/urlApps';

const initialState = {
  usuarios: {
    loading: false,
    usuarios: [],
    error: null,
    estaCargado: false
  },
  clientes: {
    loading: false,
    items: [],
    error: null,
    estaCargado: false
  }
};

export const loadUsuarios = createAsyncThunk(
  'clientes/loadUsuarios',
  async (idCliente) => {
    const response = await axios.get(`${baseUrlAlertas()}api/cliente/${idCliente}/usuarios`);
    return response.data;
  });

export const loadClientes = createAsyncThunk(
  'clientes/loadClientes',
  async () => {
    const response = await axios.get(`${baseUrlAlertas()}api/cliente`);
    return response.data;
  });

export const clientesSlice = createSlice({
  name: 'clientes',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUsuarios.pending, (state) => {
        state.usuarios.loading = true;
        state.usuarios.usuarios = [];
        state.usuarios.estaCargado = false;
        state.usuarios.error = null;
      })
      .addCase(loadUsuarios.fulfilled, (state, response) => {
        state.usuarios.loading = false;
        state.usuarios.usuarios = response.payload;
        state.usuarios.estaCargado = true;
        state.usuarios.error = null;
      })
      .addCase(loadUsuarios.rejected, (state, error) => {
        state.usuarios.loading = false;
        state.usuarios.usuarios = [];
        state.usuarios.estaCargado = true;
        state.usuarios.error = error;
      })
      .addCase(loadClientes.pending, (state) => {
        state.clientes.loading = true;
        state.clientes.items = [];
        state.clientes.estaCargado = false;
        state.clientes.error = null;
      })
      .addCase(loadClientes.fulfilled, (state, response) => {
        state.clientes.loading = false;
        state.clientes.items = response.payload;
        state.clientes.estaCargado = true;
        state.clientes.error = null;
      })
      .addCase(loadClientes.rejected, (state, error) => {
        state.clientes.loading = false;
        state.clientes.items = [];
        state.clientes.estaCargado = true;
        state.clientes.error = error;
      })
  }
});

export default clientesSlice.reducer;